import React, { Component } from 'react';
import {
  Jumbotron,
  InputGroup,
  Input,
  Label,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
} from 'reactstrap';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import reduce from 'lodash/reduce';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import { isSuperUser } from '../../../../lib/utils';

import config from '../../../../config';
import ImageUploader from '../../../../components/ImageUploader';
import JumbotronImageSlider from '../../../../components/JumbotronImageSlider';

import EditButton from '../../../../components/Buttons/EditButton';

import { savePlaceEdits, uploadPlaceImage } from '../../../../redux/actions/placeActions';

class PlaceJumbotron extends Component {
  state = {
    name: this.props.name,
    tagline: this.props.tagline,
    meters: this.props.altitude ? this.props.altitude.meters : '',
    feet: this.props.altitude ? this.props.altitude.feet : '',
    text: this.props.text,
    img: null,
  };

  render() {
    const { placeId, coverImages, banner_images } = this.props;
    const { tagline, meters, feet, text, name } = this.state;

    const images = isEmpty(coverImages)
      ? [`${config.RESOURCE_URL}/${banner_images.medium}`]
      : coverImages.map(img => `${config.RESOURCE_URL}/${img.primary_image}`);

    return (
      <div className="no-gutters" id="overview">
        <div className="col-12">
          <Jumbotron className="place-jumbotorn">
            <div className="img-wrap">
              <ImageUploader
                uploadUrl={`places/localities/${placeId}/cover_image`}
                role={isSuperUser()}
                multiple={true}
              >
                {imgUrl => <JumbotronImageSlider uploadedUrls={imgUrl} images={images} />}
              </ImageUploader>
            </div>
            <div className="row no-gutters place-jumbotorn-caption">
              <div className="col-12">
                <EditButton onEditPress={this.saveChanges}>
                  <i className="icon icon-hg-doc-text" aria-hidden="true" /> Save
                </EditButton>
                <FormGroup>
                  <InputGroup>
                    <Input value={name} name="name" onChange={this.handleChange} />
                  </InputGroup>
                </FormGroup>
                {/* ========================== TAGLINE ========================== */}
                <div className="place-edit">
                  <FormGroup>
                    <Label>Tag line</Label>
                    <InputGroup>
                      <Input name="tagline" value={tagline} onChange={this.handleChange} />
                    </InputGroup>
                  </FormGroup>
                </div>

                {/* ========================== ALTITUDE ========================== */}
                <div className="place-edit">
                  <FormGroup>
                    <Label>Altitude</Label>
                    <InputGroup>
                      <Input value={feet} name="feet" onChange={this.handleChange} />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>Feet</InputGroupText>
                      </InputGroupAddon>
                      <div className="mx-2">&nbsp;</div>
                      <Input value={meters} name="meters" onChange={this.handleChange} />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>Metre</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </div>
                {/* ========================== DESCRIPTION ========================== */}
                <div className="place-edit">
                  <FormGroup>
                    <Label>Description</Label>
                    <InputGroup>
                      <Input
                        type="textarea"
                        value={text}
                        name="text"
                        onChange={this.handleChange}
                        rows="10"
                      />
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
            </div>
          </Jumbotron>
        </div>
      </div>
    );
  }

  handleChange = e => {
    const { name, value } = e.target;

    // If key is meters or feet do coversions using ratio.
    const ratio = 3.28084;
    if (name === 'meters') {
      const meters = Math.round(Number(value));
      const feet = Math.round(meters * ratio);

      this.setState({ meters, feet });
      return;
    }

    if (name === 'feet') {
      const feet = Math.round(Number(value));
      const meters = Math.round(feet / ratio);

      this.setState({ feet, meters });
      return;
    }
    // =================================================

    this.setState({ [name]: value });
  };

  onUploadProgress = e => {
    // console.log("progress: ", Math.round(e.loaded / e.total * 100), "%");
  };

  uploadImage = async ({ handleProgress }) => {
    const { img } = this.state;
    const { placeId, uploadPlaceImage } = this.props;

    try {
      if (img) {
        await uploadPlaceImage({
          id: placeId,
          img,
          url: 'cover_image',
          onUploadProgress: handleProgress,
        });
      } else return;
    } catch (e) {
      throw e;
    }
  };

  saveData = () => {
    const {
      tagline,
      meters,
      feet,
      text,
      name,
      //  img
    } = this.state;
    const {
      placeId,
      // toggleEditing,
      savePlaceEdits,
    } = this.props;

    let dataToSave = null;
    let newData = {
      altitude: {
        feet,
        meters,
      },
      tagline,
      text,
      name,
    };

    if (feet === '') delete newData.altitude;

    const oldData = pick(this.props, ['tagline', 'text', 'altitude', 'name']);
    dataToSave = reduce(
      newData,
      function(result, value, key) {
        return isEqual(value, oldData[key]) ? result : { ...result, [key]: value };
      },
      null
    );

    if (dataToSave) {
      savePlaceEdits({
        id: placeId,
        data: dataToSave,
      });
    }
  };

  saveChanges = async () => {
    const { toggleEditing } = this.props;
    let success = true;
    try {
      await this.uploadImage({ handleProgress: this.onUploadProgress });
      await this.saveData();
    } catch (e) {
      success = false;
      alert('something went wrong');
    }
    if (success) toggleEditing();
  };
}

const mapStateToProps = ({ selectedPlace }) => {
  return {
    placeId: selectedPlace.id,
  };
};

export default connect(
  mapStateToProps,
  { savePlaceEdits, uploadPlaceImage }
)(PlaceJumbotron);



// WEBPACK FOOTER //
// ./src/screens/Places/Editor/PlacesJumbotron/PlacesJumbotornEditor.jsx